import React from 'react';
import { AdminsPage, OrganizationPage, RolePage } from 'pages';
import { ACCOUNTS_MENU_URL } from 'data/menu';

const accountsApp = [
  {
    path: ACCOUNTS_MENU_URL.단체관리,
    element: <OrganizationPage.List />,
  },
  {
    path: ACCOUNTS_MENU_URL.계정목록,
    element: <AdminsPage.List />,
  },
  {
    path: ACCOUNTS_MENU_URL.권한관리,
    element: <RolePage.List />,
  },
];

export { accountsApp };
